export function negate(filter) {
  return `!${filter}`;
}

export function generateSelectOptions(object, hasNegate, iconMap) {
  const formatName = (id, name) => {
    if (iconMap && iconMap[id]) {
      return `${iconMap[id]} ${name}`;
    }
    return name;
  };

  return [
    ...Object.entries(object).map(([id, name]) => ({ id, name: formatName(id, name) })),
    ...(hasNegate
      ? Object.entries(object).map(([id, name]) => ({ id: negate(id), name: `IS NOT ${formatName(id, name)}` }))
      : []),
  ];
}
